import { render, staticRenderFns } from "./PaymentIntegrityPicker.vue?vue&type=template&id=0b6cb3bb&scoped=true"
import script from "./PaymentIntegrityPicker.vue?vue&type=script&lang=ts"
export * from "./PaymentIntegrityPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cb3bb",
  null
  
)

export default component.exports